//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      book: {},
      totalUnitList: []
    }
  },
  computed: {
    navTitle () {
      const label = this.book.label || ''
      return label.length > 16 ? label.substring(0, 16) + '…' : label
    }
  },
  created () {
    this.book = { ...this.$route.query }
    this.loadUnitList()
  },
  methods: {
    buildRouteQuery (extra) {
      const bookId = this.$route.query.categoryId || this.$route.query.value
      return { ...this.$route.query, categoryId: bookId, ...extra }
    },
    goReturn () {
      if (this.$route.query.source) {
        this.$router.push({ path: '/home?hideTrans=true' })
        return
      }
      this.$router.push({ path: '/wordIndex?hideTrans=true' })
    },
    goBack () {
      this.$router.push({ path: '/home?hideTrans=true' })
    },
    gotoPmsCellListByBookId (book) {
      this.$router.push({
        path: '/pmsUnitCellList_display',
        query: this.buildRouteQuery({
          unitId: book.id,
          isPower: book.isPower,
          isWordPower: book.isWordPower,
          unitEn: book.unitEn
        })
      })
    },
    gotoPmsCellByBookId (book) {
      this.$router.push({
        path: '/cellIndex_display',
        query: this.buildRouteQuery({
          id: book.id,
          isWordPower: book.isWordPower,
          type: 1
        })
      })
    },
    lockUnmUnit () {
      this.$toast('目前没有购买该书本， \n请联系管理员购买。')
    },
    loadUnitList () {
      this.$ajax
        .post(this.$api.getUnitListByBookId, {
          planId: this.$route.query.value
        })
        .then(result => {
          this.totalUnitList = result || []
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/word/pmsSumUnitCellList.vue